import { TradingOfferType } from 'types/TradingOffer';

import { TradingOffersListProvider } from '../pages/TradingOffersList/context/TradingOffersListContext';
import TradingOffersList from '../pages/TradingOffersList';

const TradingOffersListContainer = () => (
  <TradingOffersListProvider>
    <TradingOffersList tradingOfferType={TradingOfferType.BUY} />
  </TradingOffersListProvider>
);

export default TradingOffersListContainer;
